<!--
 * @Author: Vben
 * @Description: logo component
-->
<template>
  <div class="anticon" @click="goHome">
    <img class="app_log" src="../../assets/layout/logo.png" />
  </div>
</template>
<script lang="ts" setup>
interface Props {
  collapsed: boolean;
}

defineProps<Props>();

const title = import.meta.env.VITE_PORTAL_NAME;

function goHome() {
  //   go(userStore.getUserInfo.homePath || PageEnum.BASE_HOME);
}
</script>
<style lang="scss" scoped>
.anticon {
  position: relative;
  display: flex;
  color: #0960bd;
  align-items: center;
  width: 100%;
}
.title {
  transition: all 0.5s;
  font-size: 16px;
  font-weight: 800;
  line-height: normal;
  margin-left: 10px;
  display: inline-block;
  white-space: nowrap;
}
.app_log {
  position: relative;
  width: 80px;
}
</style>
